<template>
  <div>
    <slot v-bind="{ items }"/>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { differenceBy, map } from "lodash-es"
import { useSchools } from "@/composables/useSchools"

const props = defineProps({
  budgets: { type: Array, required: true },
})

const { schools } = useSchools()

const items = computed(() => {
  return differenceBy(schools, map(props.budgets, "school"), "id")
})
</script>
